import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { PROXY } from "../lib/utils";

const GoogleLoginButton = ({ label = "Continue with Google" }) => {
  const { googleLoginSuccess } = useAuth();

  return (
    <div className="w-full">
      <p className="mb-3 text-center text-sm font-medium text-gray-600">
        {label}
      </p>
      <div className="flex justify-center">
        <GoogleLogin
          width="320"
          size="large"
          shape="pill"
          theme="outline"
          text="continue_with"
          onSuccess={async (credentialResponse) => {
            try {
              const res = await axios.post(
                `${PROXY}/auth/google`,
                { credential: credentialResponse.credential },
                { withCredentials: true }
              );

              toast.success("Google login successful");
              googleLoginSuccess(res.data.accessToken, res.data.user);
            } catch (err) {
              console.error("Google login failed", err);
              toast.error(
                err?.response?.data?.message || "Google login failed"
              );
            }
          }}
          onError={() => {
            console.error("Google Login Failed");
            toast.error("Google login failed");
          }}
        />
      </div>
    </div>
  );
};

export default GoogleLoginButton;
